import { render, staticRenderFns } from "./Rejeitadas.vue?vue&type=template&id=45d69790"
import script from "./Rejeitadas.vue?vue&type=script&lang=js"
export * from "./Rejeitadas.vue?vue&type=script&lang=js"
import style0 from "./Rejeitadas.vue?vue&type=style&index=0&id=45d69790&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports